
import React from "react";
import { bool, func } from "prop-types";
import { ReactComponent as ArrowRightIcon } from "../../../assets/images/icons/arrowRight.svg";
import { withStyles } from "@material-ui/core";

const RightNav = React.memo(({
	disabled,
	onClick
}) => {
	return (
		<button
			type="button"
			className="right-nav-button"
			disabled={disabled}
			onClick={onClick}
			aria-label="Next Slide"
		>
			<ArrowRightIcon icon="right" />
		</button>
	);
});

RightNav.displayName = "RightNav";

RightNav.propTypes = {
	disabled: bool.isRequired,
	onClick: func.isRequired
};


export default RightNav;
